(function(){
'use strict';
var d=document,LS='pf_wishlist';
function $(s,c){return (c||d).querySelector(s)}
function $$(s,c){return Array.prototype.slice.call((c||d).querySelectorAll(s))}
var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var cartUrl=(window.routes&&window.routes.cart_url)||'/cart';

/* scroll reveal */
function initReveal(root){
  var els=$$('.pf-reveal:not(.is-in)',root);
  if(!('IntersectionObserver' in window)||reduce||(window.Shopify&&window.Shopify.designMode)){els.forEach(function(e){e.classList.remove('pf-reveal')});return}
  var io=new IntersectionObserver(function(en){en.forEach(function(x){if(!x.isIntersecting)return;var e=x.target;io.unobserve(e);e.classList.add('is-in');setTimeout(function(){e.classList.remove('pf-reveal','is-in')},1700)})},{rootMargin:'0px 0px -6% 0px'});
  els.forEach(function(e){io.observe(e)});
}

/* toast + emoji burst */
var tEl,tTo;
function toast(m){if(!tEl){tEl=d.createElement('div');tEl.className='pf-toast';tEl.setAttribute('role','status');d.body.appendChild(tEl)}tEl.textContent=m;tEl.classList.add('is-on');clearTimeout(tTo);tTo=setTimeout(function(){tEl.classList.remove('is-on')},2200)}
function burst(el,chars){
  if(reduce||!el||!el.animate)return;
  var r=el.getBoundingClientRect(),cx=r.left+r.width/2,cy=r.top+r.height/2;
  chars=chars||['🐾','🦴','✨','💛','🎉'];
  for(var i=0;i<14;i++){(function(i){
    var s=d.createElement('span');s.className='pf-conf';s.textContent=chars[i%chars.length];s.style.left=cx+'px';s.style.top=cy+'px';d.body.appendChild(s);
    var ang=Math.random()*Math.PI*2,dist=60+Math.random()*90,x=Math.cos(ang)*dist,y=Math.sin(ang)*dist-40;
    var an=s.animate([{transform:'translate(-50%,-50%) scale(.4)',opacity:1},{transform:'translate(calc(-50% + '+x+'px),calc(-50% + '+y+'px)) scale(1.2) rotate('+Math.round(Math.random()*360)+'deg)',opacity:1,offset:.7},{transform:'translate(calc(-50% + '+x+'px),calc(-50% + '+(y+60)+'px)) scale(.8)',opacity:0}],{duration:900+Math.random()*400,easing:'cubic-bezier(.2,.8,.3,1)'});
    an.onfinish=function(){s.remove()};
  })(i)}
}

/* wishlist (saved in the browser) */
function getWish(){try{return JSON.parse(localStorage.getItem(LS))||[]}catch(e){return []}}
function setWish(a){try{localStorage.setItem(LS,JSON.stringify(a))}catch(e){}}
function syncWish(){
  var a=getWish(),h=a.map(function(i){return i.handle});
  $$('[data-pf-wish]').forEach(function(b){var on=h.indexOf(b.getAttribute('data-handle'))>-1;b.classList.toggle('is-on',on);b.setAttribute('aria-pressed',on)});
  $$('[data-pf-wish-count]').forEach(function(c){c.textContent=a.length?a.length:''});
}
function toggleWish(b){
  var a=getWish(),h=b.getAttribute('data-handle'),i=-1;
  a.forEach(function(x,k){if(x.handle===h)i=k});
  if(i>-1){a.splice(i,1);toast('Removed from wishlist')}
  else{a.push({handle:h,title:b.getAttribute('data-title'),url:b.getAttribute('data-url'),img:b.getAttribute('data-img'),price:b.getAttribute('data-price')});toast('Saved to wishlist 💛');burst(b,['💛','🐾','✨'])}
  setWish(a);syncWish();
}
function renderWish(){
  var box=$('[data-pf-wish-list]');if(!box)return;
  var a=getWish();box.textContent='';
  if(!a.length){var p=d.createElement('p');p.className='pf-wl__empty';p.textContent='Nothing saved yet. Tap the heart on anything you love 🐾';box.appendChild(p);return}
  a.forEach(function(i){
    var r=d.createElement('div');r.className='pf-wl__item';
    var im=d.createElement('img');im.alt='';im.loading='lazy';if(i.img)im.src=i.img;
    var m=d.createElement('div'),l=d.createElement('a'),s=d.createElement('small');
    l.href=i.url;l.textContent=i.title;s.textContent=i.price||'';m.appendChild(l);m.appendChild(s);
    var x=d.createElement('button');x.type='button';x.className='pf-wl__x';x.setAttribute('data-pf-unwish',i.handle);x.setAttribute('aria-label','Remove');x.textContent='×';
    r.appendChild(im);r.appendChild(m);r.appendChild(x);box.appendChild(r);
  });
}

/* drawers */
function openD(el){if(!el)return;el.classList.add('is-open');el.setAttribute('aria-hidden','false');d.documentElement.style.overflow='hidden'}
function closeD(el){el.classList.remove('is-open');el.setAttribute('aria-hidden','true');d.documentElement.style.overflow=''}

d.addEventListener('click',function(e){
  var t=e.target.closest('[data-pf-open]');
  if(t){e.preventDefault();var id=t.getAttribute('data-pf-open');if(id==='wish')renderWish();openD(d.getElementById('pf-drawer-'+id));return}
  if(e.target.closest('[data-pf-close]')){var dr=e.target.closest('.pf-drawer');if(dr)closeD(dr);return}
  var c=e.target.closest('[data-pf-cart]');
  if(c){e.preventDefault();var b=d.getElementById('cart-icon-bubble');if(b)b.click();else location.href=cartUrl;return}
  var w=e.target.closest('[data-pf-wish]');
  if(w){e.preventDefault();toggleWish(w);return}
  var rm=e.target.closest('[data-pf-unwish]');
  if(rm){var hh=rm.getAttribute('data-pf-unwish');setWish(getWish().filter(function(i){return i.handle!==hh}));renderWish();syncWish();return}
  var tb=e.target.closest('[data-pf-tab]');
  if(tb){var box=tb.closest('[data-pf-tabs]'),key=tb.getAttribute('data-pf-tab');$$('[data-pf-tab]',box).forEach(function(x){x.classList.toggle('is-active',x===tb);x.setAttribute('aria-selected',x===tb)});$$('[data-pf-panel]',box).forEach(function(p){p.hidden=p.getAttribute('data-pf-panel')!==key});return}
  var ar=e.target.closest('[data-pf-prev],[data-pf-next]');
  if(ar){var tr=$('.pf-track',ar.closest('.pf-rail'));if(tr){var dir=ar.hasAttribute('data-pf-next')?1:-1;tr.scrollBy({left:dir*tr.clientWidth*0.8,behavior:reduce?'auto':'smooth'})}}
});
d.addEventListener('keydown',function(e){if(e.key==='Escape')$$('.pf-drawer.is-open').forEach(closeD)});

/* quick add to cart */
d.addEventListener('submit',function(e){
  var f=e.target.closest('form[data-pf-add]');if(!f)return;
  e.preventDefault();
  var btn=f.querySelector('[type=submit]'),lab=btn.querySelector('span');
  if(btn.classList.contains('is-loading'))return;
  btn.classList.add('is-loading');
  var cart=$('cart-drawer')||$('cart-notification'),fd=new FormData(f);
  if(cart&&cart.getSectionsToRender){try{fd.append('sections',cart.getSectionsToRender().map(function(s){return s.id}));fd.append('sections_url',location.pathname);if(cart.setActiveElement)cart.setActiveElement(btn)}catch(er){}}
  fetch((window.routes&&window.routes.cart_add_url)||'/cart/add',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/javascript'},body:fd})
  .then(function(r){return r.json()})
  .then(function(j){
    if(j.status){toast(j.description||j.message||'Sorry, that could not be added');return}
    burst(btn);
    var old=lab?lab.textContent:'';btn.classList.add('is-done');if(lab)lab.textContent='Added!';
    setTimeout(function(){btn.classList.remove('is-done');if(lab)lab.textContent=old},1600);
    if(cart&&cart.renderContents){cart.classList.remove('is-empty');try{cart.renderContents(j)}catch(er){location.href=cartUrl}}
    else{location.href=cartUrl}
  })
  .catch(function(){f.removeAttribute('data-pf-add');f.submit()})
  .then(function(){btn.classList.remove('is-loading')});
});

/* header, progress bar, back to top */
function initChrome(){
  var sec=$('.pf-header-section');if(!sec)return;
  if($('.pf-tabbar'))d.body.classList.add('pf-has-tabbar');
  var bar=d.createElement('div');bar.className='pf-progress';d.body.appendChild(bar);
  var top=d.createElement('button');top.className='pf-top';top.type='button';top.setAttribute('aria-label','Back to top');top.textContent='🐾';d.body.appendChild(top);
  top.addEventListener('click',function(){window.scrollTo({top:0,behavior:reduce?'auto':'smooth'})});
  var tick=false;
  function on(){var y=window.scrollY||0,h=d.documentElement.scrollHeight-window.innerHeight;sec.classList.toggle('is-scrolled',y>80);top.classList.toggle('is-on',y>600);bar.style.transform='scaleX('+(h>0?Math.min(1,y/h):0)+')';tick=false}
  window.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(on)}},{passive:true});
  on();
  var cb=d.getElementById('cart-icon-bubble');
  if(cb&&window.MutationObserver){new MutationObserver(function(){cb.classList.remove('is-pop');void cb.offsetWidth;cb.classList.add('is-pop');var n=$('.cart-count-bubble span',cb);$$('[data-pf-cart-count]').forEach(function(c){c.textContent=n?n.textContent:''})}).observe(cb,{childList:true})}
}

function boot(){initChrome();initReveal(d);syncWish()}
if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',boot);else boot();
d.addEventListener('shopify:section:load',function(e){initReveal(e.target);syncWish()});
})();
